<template>
  <div class="render">
    <div class="top">
      <h1>Аналитика</h1>
    </div>

    <div class="my_toolbar">
      <v-tabs v-model="tab" align-with-title>
        <v-tabs-slider color="yellow" />
        <v-tab
          v-for="item in tabs"
          :key="item"
          class="item_tab"
          active-class="my_active_tab"
        >
          {{ item }}
        </v-tab>
      </v-tabs>
    </div>

    <div class="content_table">
      <v-tabs-items v-model="tab">
        <v-tab-item key="Цели">
          <FilterReports
            :page_type="'reports'"
            :selects="selects_load"
            :callback="renderTargets"
            @export="exportTargets"
          />
          <Table
            :server="false"
            :hideselect="true"
            :loading="loading_target"
            :headers="table.headers_targets"
            :data="table.targets.data"
            :perPage="perPage"
            :callback_refresh="renderTargets"
          />
        </v-tab-item>

        <v-tab-item key="Скрипты обзвона">
          <FilterReports
            :page_type="'scripts'"
            :selects="selects_load"
            :callback="renderScripts"
            @export="exportScripts"
          />
          <Table
            :server="false"
            :hideselect="true"
            :loading="loading_scripts"
            :headers="table.headers_scripts"
            :data="table.scripts.data"
            :perPage="perPage"
            :callback_refresh="renderScripts"
          />
        </v-tab-item>

        <v-tab-item key="Базы номеров">
          <FilterReports
            :page_type="'bases'"
            :selects="selects_load"
            :callback="renderBases"
            @export="exportBases"
          />
          <Table
            :server="false"
            :hideselect="true"
            :loading="loading_bases"
            :headers="table.headers_bases"
            :data="table.bases.data"
            :perPage="perPage"
            :callback_refresh="renderBases"
          />
        </v-tab-item>

        <v-tab-item key="Источники">
          <FilterReports
            :page_type="'sources'"
            :selects="selects_load"
            :callback="renderSources"
            @export="exportSources"
          />
          <Table
            :server="false"
            :hideselect="true"
            :loading="loading_sources"
            :headers="table.headers_sources"
            :data="table.sources.data"
            :perPage="perPage"
            :callback_refresh="renderSources"
          />
        </v-tab-item>
      </v-tabs-items>
    </div>
  </div>
</template>

<script>

import Table from '@/components/Table/DataTable.vue'
import FilterReports from '@/components/Filter/ReportsFilter.vue'

import { Chart as ChartJS, ArcElement, CategoryScale } from 'chart.js'
ChartJS.register(ArcElement, CategoryScale)

export default {
  name: 'AnalyticsPage',
  components: { Table, FilterReports },

  data () {
    return {
      tab: 'Цели',
      tabs: ['Цели', 'Скрипты обзвона', 'Базы номеров', 'Источники'],
      perPage: 10,

      loading_target: true,
      loading_scripts: true,
      loading_bases: true,
      loading_sources: true,

      selects_load: {
        scripts: [],  
        sources: [],   
        calls:   [],   
        bases:   []    
      },

      table: {
        targets: { data: [] },
        scripts: { data: [] },
        bases:   { data: [] },
        sources: { data: [] },

        headers_targets: [
          { text: 'Цель', value: 'Target_Name' },
          { text: 'Количество', value: 'Amount_Target' },
          { text: 'Скрипт', value: 'Id_Script' },
          { text: 'Цена одной конверсии', value: 'Price_One_Target' },
          { text: 'Процент достижения (от прозвоненных)', value: 'Percent_Target_From_Calls' },
          { text: 'Процент достижения (от дозвонов)', value: 'Percent_Target_From_Answered' }
        ],

        headers_scripts: [
          { text: 'Скрипт', value: 'Id_Script' },
          { text: 'Кол-во успешных звонков', value: 'Successful_Calls' },
          { text: 'Процент успешных звонков (от прозвоненных контактов)', value: 'Percent_Success_From_Called' },
          { text: 'Процент успешных звонков (от дозвонов)', value: 'Percent_Success_From_Connected' },
          { text: 'Цена успешного звонка', value: 'Price_Success_Call' },
          { text: 'Всего вызовов', value: 'Total_Calls' },
          { text: 'Контактов прозвонено', value: 'Total_Clients_Called' },
          { text: 'Дозвонов', value: 'Connected_Calls' },
          { text: 'Процент дозвона', value: 'Connection_Rate' },
          { text: 'Расход', value: 'Expense', cellClass: 'no-wrap' }
        ],

        headers_bases: [
          { text: 'Базы номеров', value: 'Id_Base' },
          { text: 'Кол-во успешных звонков', value: 'Successful_Calls' },
          { text: 'Процент успешных звонков (от прозвоненных контактов)', value: 'Percent_Success_From_Called' },
          { text: 'Процент успешных звонков (от дозвонов)', value: 'Percent_Success_From_Connected' },
          { text: 'Цена успешного звонка', value: 'Price_Success_Call' },
          { text: 'Всего вызовов', value: 'Total_Calls' },
          { text: 'Контактов прозвонено', value: 'Total_Clients_Called' },
          { text: 'Дозвонов', value: 'Connected_Calls' },
          { text: 'Процент дозвона', value: 'Connection_Rate' },
          { text: 'Расход', value: 'Expense', cellClass: 'no-wrap' }
        ],

        headers_sources: [
          { text: 'Источник', value: 'Source' },
          { text: 'Кол-во успешных звонков', value: 'Successful_Calls' },
          { text: 'Процент успешных звонков (от прозвоненных контактов)', value: 'Percent_Success_From_Called' },
          { text: 'Процент успешных звонков (от дозвонов)', value: 'Percent_Success_From_Connected' },
          { text: 'Цена успешного звонка', value: 'Price_Success_Call' },
          { text: 'Всего вызовов', value: 'Total_Calls' },
          { text: 'Контактов прозвонено', value: 'Total_Clients_Called' },
          { text: 'Дозвонов', value: 'Connected_Calls' },
          { text: 'Процент дозвона', value: 'Connection_Rate' },
          { text: 'Расход', value: 'Expense', cellClass: 'no-wrap' }
        ]
      }
    }
  },

  mounted () {
    this.loadSourcesFilters()
    this.renderTargets()
    this.renderScripts()
    this.renderBases()
    this.renderSources()
  },

  methods: {
   formatData (data) {
     return data.map(row => {
       const newRow = { ...row }
      Object.keys(newRow).forEach(key => {
         const val = newRow[key]
         if (val == null) return

         if (/percent|rate/i.test(key)) {
           newRow[key] = `${val}%`
         } else if (/price|expense/i.test(key)) {
            newRow[key] = `${val}\u00A0₽`;
         }
       })
       return newRow
     })
   },
    loadSourcesFilters () {
      try {
        this.$http.post('/reports/sources_filters', {}, (resp) => {
        const norm = (v) => {
         if (v && typeof v === 'object') {
            return {
             id:   v.id   ?? v.value ?? v.name   ?? String(v),
              name: v.name ?? v.label ?? v.value ?? String(v)
            }
          }
          return { id: v, name: v }
       }

        this.selects_load.sources = resp.sources.map(norm)
        this.selects_load.scripts = resp.scripts.map(norm)
        this.selects_load.bases   = resp.bases  .map(norm)
        this.selects_load.calls   = resp.calls  .map(norm)
        })
      } catch (e) {
        console.error(e)
      }
    },

    async renderTargets (filters = {}) {
      this.loading_target = true
      try {
        this.$http.post('/reports/target', filters, (data) => {
           this.table.targets.data = this.formatData(data)
          this.loading_target = false
          this.loadSourcesFilters()
       })
      } catch (e) {
        console.error(e)
        this.loading_target = false
      }
    },

    renderScripts (filters = {}) {
      this.loading_scripts = true
      try {
        this.$http.post('/reports/scripts', filters, (data) => {
           this.table.scripts.data = this.formatData(data)
          this.loading_scripts = false
        })
      } catch (e) {
        console.error(e)
        this.loading_scripts = false
      }
    },

    renderBases (filters = {}) {
      this.loading_bases = true
      try {
        this.$http.post('/reports/bases', filters, (data) => {
          this.table.bases.data = this.formatData(data)
          this.loading_bases = false
        })
      } catch (e) {
        console.error(e)
        this.loading_bases = false
      }
    },

    renderSources (filters = {}) {
      this.loading_sources = true
      try {
        this.$http.post('/reports/sources', filters, (data) => {
          this.table.sources.data = this.formatData(data)
          this.loading_sources = false

        })
      } catch (e) {
        console.error(e)
        this.loading_sources = false
      }
    },

    exportTargets (payload) {
      this.exportExcel('/reports/target/export', payload, 'targets.xlsx')
    },

    exportScripts (payload) {
      this.exportExcel('/reports/scripts/export', payload, 'scripts.xlsx')
    },

    exportBases (payload) {
      this.exportExcel('/reports/bases/export', payload, 'bases.xlsx')
    },

    exportSources (payload) {
      this.exportExcel('/reports/sources/export', payload, 'sources.xlsx')
    },

exportExcel (url, payload, filename) {
  this.excelLoading = true

  if (localStorage.token) {
    payload = { ...payload, token: localStorage.token }
  }

  this.$http.axios
    .post(url, payload, { responseType: 'blob' })
    .then((res) => {
      this.excelLoading = false

      const blobUrl = URL.createObjectURL(new Blob([res.data]))
      const a = document.createElement('a')
      a.href = blobUrl
      a.download = filename
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      URL.revokeObjectURL(blobUrl)
    })
    .catch((err) => {
      this.excelLoading = false
      console.error('Export error:', err)
      alert('Не удалось скачать отчёт')
    })
}
  }
}
</script>

<style scoped>
.content_table {
  margin-top: 24px;
}

.blocks {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.no-wrap {
  white-space: nowrap;
}
.add {
  border: none;
  padding: 12px 20px 12px 22px;
  background: #fee600 !important;
  border-radius: 8px;
  font-weight: 600;
  font-size: 15px;
  line-height: 120%;
  text-align: center;
  color: #2b2d33;
  cursor: pointer;
  display: flex;
  margin-top: 24px;
  justify-content: center;
}

.add .icon {
  margin-right: 11px;
}

.item_tab {
  text-transform: none !important;
  font-style: normal;
  font-weight: 600;
  font-size: 17px;
  line-height: 120%;
  color: #808185;
}

.my_active_tab {
  color: #2b2d33;
}

.my_toolbar {
  margin-top: 16px;
}

.num_big {
  font-style: normal;
  font-weight: 800;
  font-size: 24px;
  line-height: 130%;
  text-align: center;
  color: #404247;
  max-width: 75px;
  position: absolute;
  top: 55px;
  width: 75px;
  left: 51px;
}

.block_item {
  padding: 16px 24px;
  border-radius: 8px;

  width: 265px;
  margin-bottom: 36px;
}

.block_item:nth-child(odd) {
  margin-right: 20px;
}

.small_blocks {
  display: flex;
  flex-wrap: wrap;
  margin-top: 30px;
  justify-content: center;
}

.block_item .heading {
  font-style: normal;
  font-weight: 600;
  font-size: 17px;
  line-height: 120%;
  color: #404247;
  margin-bottom: 12px;
  text-align: left;
}

.block_item .num {
  font-style: normal;
  font-weight: 800;
  font-size: 24px;
  line-height: 130%;
  color: #404247;
  text-align: left;
}

.my_red .num {
  color: #ee505a;
}

.my_gray {
  background: #f8f8f8;
}

.my_red {
  background: #fdeeee;
}

.my_green {
  background: #e8f7f4;
}

.block {
  display: flex;
  flex-wrap: wrap;
  padding: 32px 24px;
  justify-content: center;
  max-width: 600px;
}

.big_block {
  background: #e8f7f4;
  border-radius: 8px;
  display: flex;
  padding: 24px 16px;
  min-width: 500px;
  max-height: 230px;
}

.right {
  margin-left: 32px;
}

.heading {
  font-style: normal;
  font-weight: 800;
  font-size: 24px;
  text-align: left;
  line-height: 130%;
  color: #404247;
}

.robot,
.client,
.silence {
  text-align: left;
  position: relative;
  margin-top: 24px;
  font-style: normal;
  font-weight: 500;
  font-size: 17px;
  padding-left: 25px;
  line-height: 120%;
  color: #404247;
}

.robot:before {
  display: block;
  content: "";
  width: 18px;
  height: 18px;
  background: #faa373;
  border-radius: 50%;
  position: absolute;
  left: 0;
  top: 0;
}

.client:before {
  display: block;
  content: "";
  width: 18px;
  height: 18px;
  background: #57b6ed;
  border-radius: 50%;
  position: absolute;
  left: 0;
  top: 0;
}

.silence:before {
  display: block;
  content: "";
  width: 18px;
  height: 18px;
  background: #9a99fb;
  border-radius: 50%;
  position: absolute;
  left: 0;
  top: 0;
}

.content {
  height: 100%;
  display: flex;
  position: relative;
  z-index: 1000;
}

.empty {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  height: 500px;
}

.subtitle {
  max-width: 450px;
  margin-bottom: 32px;
}

.left {
  position: relative;
}

@media (max-width: 1000px) {
  .filters {
    flex-direction: column;
  }
}

@media (max-width: 650px) {
  .top {
    justify-content: center;
  }

  .big_block {
    flex-direction: column;
    max-height: initial;
    min-width: initial;
  }

  .num_big {
    left: calc(50% - 36px);
  }

  .right {
    margin-left: 0;
  }
}

@media (max-width: 620px) {
  .block_item:nth-child(odd) {
    margin-right: 0;
  }

  .small_blocks {
    flex-direction: column;
  }
}

@media (max-width: 400px) {
  h1 {
    margin-top: 15px;
  }
}
</style>